// Modul-Registry – Systemhaus-Manager
// Central module definitions used by both backend and frontend
/** Stable order in which categories are rendered (menu + settings). */
export const MODULE_CATEGORY_ORDER = [
    'Mein Arbeitsplatz',
    'Kunden',
    'Lieferanten',
    'Vertrieb',
    'Finanzen',
    'Stammdaten',
    'Disposition',
    'Administration',
];
// ─── Module Definitions ────────────────────────────────────────────────────
export const MODULE_DEFINITIONS = [
    // M1: Dashboard
    {
        id: 'dashboard',
        name: 'Dashboard',
        description: 'Persönlicher Arbeitsplatz und Tagesübersicht',
        category: 'Mein Arbeitsplatz',
        defaultStatus: 'stable',
        routes: ['/dashboard'],
        icon: 'LayoutDashboard',
        menuEntries: [
            { route: '/dashboard', label: 'Mein Tag', description: 'Dashboard & Übersicht' },
        ],
        dashboardWidgets: [
            { id: 'ticket-my-open', name: 'Meine offenen Tickets', description: 'Eigene zugewiesene offene Tickets', defaultSize: { w: 6, h: 4 }, moduleId: 'dashboard' },
            { id: 'ticket-unassigned', name: 'Nicht zugewiesene Tickets', description: 'Tickets ohne Zuweisung', defaultSize: { w: 6, h: 4 }, moduleId: 'dashboard' },
            { id: 'ticket-all', name: 'Alle Tickets', description: 'Übersicht aller offenen Tickets', defaultSize: { w: 12, h: 4 }, moduleId: 'dashboard' },
            { id: 'ticket-overdue', name: 'Überfällige Tickets', description: 'Tickets über SLA-Frist', defaultSize: { w: 6, h: 3 }, moduleId: 'dashboard' },
        ],
        embeddableWidgets: [],
    },
    // M1b: Mein Tag (To-Do-Aggregation)
    {
        id: 'my-day',
        name: 'Mein Tag',
        description: 'Zentrale To-Do-Übersicht: TANSS, SAP, E-Mail',
        category: 'Mein Arbeitsplatz',
        defaultStatus: 'stable',
        routes: ['/my-day'],
        icon: 'ListTodo',
        menuEntries: [
            { route: '/my-day', label: 'To-Dos', description: 'Offene Aufgaben aus TANSS, SAP & E-Mail' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // CMDB: Zentrale Asset-Übersicht
    {
        id: 'cmdb',
        name: 'CMDB',
        description: 'Zentrale Asset-Datenbank: alle Geräte aus NinjaOne, UniFi und weiteren Quellen',
        category: 'Kunden',
        menuSubGroup: 'Infrastruktur & Technik',
        defaultStatus: 'beta',
        routes: ['/cmdb'],
        icon: 'Database',
        menuEntries: [
            { route: '/cmdb', label: 'CMDB', description: 'Alle Assets aus allen Quellen' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M2: Tickets
    {
        id: 'tickets',
        name: 'Tickets',
        description: 'Support-Tickets und Kundenanfragen',
        category: 'Kunden',
        menuSubGroup: 'Service',
        defaultStatus: 'stable',
        routes: ['/tickets'],
        icon: 'Ticket',
        menuEntries: [
            { route: '/tickets', label: 'Tickets', description: 'Support & Anfragen' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M3: Zeiterfassung
    {
        id: 'zeiterfassung',
        name: 'Zeiterfassung',
        description: 'Stempeln, Zeiten buchen und Wochenübersicht',
        category: 'Mein Arbeitsplatz',
        defaultStatus: 'stable',
        routes: ['/zeiterfassung'],
        icon: 'Clock',
        menuEntries: [
            { route: '/zeiterfassung', label: 'Zeiterfassung', description: 'Stempeln & Zeiten' },
        ],
        dashboardWidgets: [
            { id: 'time-status', name: 'Arbeitszeitstatus', description: 'Heutige Arbeitszeit und Status', defaultSize: { w: 4, h: 2 }, moduleId: 'zeiterfassung' },
            { id: 'time-week', name: 'Wochenübersicht', description: 'Stunden pro Tag diese Woche', defaultSize: { w: 6, h: 3 }, moduleId: 'zeiterfassung' },
        ],
        embeddableWidgets: [],
    },
    // M4: Kalender
    {
        id: 'kalender',
        name: 'Kalender',
        description: 'Terminplanung mit M365-Sync',
        category: 'Mein Arbeitsplatz',
        defaultStatus: 'beta',
        routes: ['/kalender'],
        icon: 'Calendar',
        menuEntries: [
            { route: '/kalender', label: 'Kalender', description: 'Termine & Planung' },
        ],
        dashboardWidgets: [
            { id: 'calendar-today', name: 'Heutige Termine', description: 'Termine für heute', defaultSize: { w: 4, h: 4 }, moduleId: 'kalender' },
        ],
        embeddableWidgets: [],
    },
    // M5: Telefonie
    {
        id: 'telefonie',
        name: 'Telefonie',
        description: 'Anrufe und Rückrufverwaltung',
        category: 'Kunden',
        menuSubGroup: 'Service',
        defaultStatus: 'beta',
        routes: ['/telefonie'],
        icon: 'Phone',
        menuEntries: [
            { route: '/telefonie', label: 'Telefonie', description: 'Anrufe & Rückrufe' },
        ],
        dashboardWidgets: [
            { id: 'calls-today', name: 'Anrufe heute', description: 'Eingehend/Ausgehend/Verpasst', defaultSize: { w: 4, h: 2 }, moduleId: 'telefonie' },
            { id: 'callbacks-open', name: 'Offene Rückrufe', description: 'Noch zu erledigende Rückrufe', defaultSize: { w: 4, h: 3 }, moduleId: 'telefonie' },
        ],
        embeddableWidgets: [],
    },
    // M6: Netzwerk & Geräteverwaltung
    {
        id: 'netzwerk',
        name: 'Netzwerkübersicht',
        description: 'UniFi-Sites, Geräte und Topologie',
        category: 'Kunden',
        menuSubGroup: 'Infrastruktur & Technik',
        defaultStatus: 'stable',
        routes: ['/netzwerk', '/netzwerk/visualisierung'],
        icon: 'Network',
        menuEntries: [
            { route: '/netzwerk', label: 'Netzwerkübersicht', description: 'Sites & Geräte' },
            { route: '/netzwerk/visualisierung', label: 'Netzwerkvisualisierung', description: 'Topologie-Grafik', icon: 'GitBranch' },
        ],
        dashboardWidgets: [
            { id: 'network-status', name: 'Netzwerkstatus', description: 'Online/Offline Geräte', defaultSize: { w: 4, h: 3 }, moduleId: 'netzwerk' },
        ],
        embeddableWidgets: [],
    },
    // UniFi Integration
    {
        id: 'unifi',
        name: 'UniFi',
        description: 'UniFi-Sites, Geräte und Alerts',
        category: 'Kunden',
        menuSubGroup: 'Infrastruktur & Technik',
        defaultStatus: 'stable',
        routes: ['/unifi'],
        icon: 'Wifi',
        menuEntries: [
            { route: '/unifi', label: 'UniFi', description: 'Sites & Geräte' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // NinjaOne Geräteübersicht
    {
        id: 'ninja-devices',
        name: 'NinjaOne Geräte',
        description: 'Zentrale Geräteübersicht aller NinjaOne-verwalteten Endgeräte',
        category: 'Kunden',
        menuSubGroup: 'Infrastruktur & Technik',
        defaultStatus: 'beta',
        routes: ['/infrastruktur/geraete'],
        icon: 'Monitor',
        menuEntries: [
            { route: '/infrastruktur/geraete', label: 'NinjaOne Geräte', description: 'Alle Endgeräte aller Kunden' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M7: Monitoring
    {
        id: 'monitoring',
        name: 'Monitoring',
        description: 'ESET, CWA, MailStore, NoSpamProxy Status',
        category: 'Kunden',
        menuSubGroup: 'Infrastruktur & Technik',
        defaultStatus: 'stable',
        routes: ['/monitoring'],
        icon: 'Monitor',
        menuEntries: [
            { route: '/monitoring', label: 'Monitoring', description: 'Status & Alerts' },
        ],
        dashboardWidgets: [
            { id: 'monitoring-alerts', name: 'Aktive Alerts', description: 'Warnungen und Fehler aus allen Systemen', defaultSize: { w: 6, h: 3 }, moduleId: 'monitoring' },
        ],
        embeddableWidgets: [],
    },
    // M8: Passwortmanagement
    {
        id: 'passwort',
        name: 'Passwortmanagement',
        description: 'Passwort-Generator und sicherer Versand',
        category: 'Kunden',
        menuSubGroup: 'Infrastruktur & Technik',
        defaultStatus: 'stable',
        routes: ['/passwort/versenden', '/passwort/generator'],
        icon: 'Key',
        menuEntries: [
            { route: '/passwort/versenden', label: 'Passwort versenden', description: 'Sicher an Kunden senden' },
            { route: '/passwort/generator', label: 'Passwort-Generator', description: 'Sichere Passwörter erzeugen' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [
            { id: 'password-generator', name: 'Passwort-Generator', description: 'Sicheres Passwort erzeugen', targets: ['ticket-detail'], moduleId: 'passwort' },
            { id: 'password-send', name: 'Passwort versenden', description: 'Passwort per SMS/E-Mail senden', targets: ['ticket-detail'], moduleId: 'passwort' },
        ],
    },
    // M9: SAP Dokumente (Angebote, Aufträge, Lieferscheine, Rechnungen, Gutschriften)
    {
        id: 'sap-auftraege',
        name: 'Dokumente',
        description: 'SAP Business One – Angebote, Aufträge, Lieferscheine, Rechnungen, Gutschriften',
        category: 'Vertrieb',
        defaultStatus: 'stable',
        routes: ['/dokumente', '/auftraege'],
        icon: 'FileText',
        menuEntries: [
            { route: '/dokumente', label: 'Dokumente', description: 'Angebote, Aufträge, Rechnungen & mehr' },
        ],
        dashboardWidgets: [
            { id: 'sap-recent', name: 'Letzte Angebote/Aufträge', description: 'Die neuesten SAP-Dokumente', defaultSize: { w: 6, h: 4 }, moduleId: 'sap-auftraege' },
        ],
        embeddableWidgets: [
            { id: 'sap-create', name: 'SAP-Dokument erstellen', description: 'Angebot/Auftrag aus Ticket', targets: ['ticket-detail'], moduleId: 'sap-auftraege' },
        ],
    },
    // M10: ALSO Marketplace & Lizenzverwaltung
    {
        id: 'marketplace',
        name: 'ALSO Marketplace',
        description: 'Lizenzbeschaffung und Verwaltung',
        category: 'Lieferanten',
        defaultStatus: 'stable',
        routes: ['/marketplace'],
        icon: 'ShoppingCart',
        menuEntries: [
            { route: '/marketplace', label: 'ALSO Marketplace', description: 'Produkte bestellen' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M11: Versand (DHL / E-POST / PENSAKI)
    {
        id: 'versand',
        name: 'Versand',
        description: 'Briefpost (E-POST), Paketscheine (DHL), handgeschriebene Briefe (PENSAKI)',
        category: 'Mein Arbeitsplatz',
        defaultStatus: 'stable',
        routes: ['/versand'],
        icon: 'Package',
        menuEntries: [
            { route: '/versand', label: 'Versand', description: 'Brief & Paket an Kunden/Lieferanten', icon: 'Send' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [
            { id: 'shipping-send', name: 'Versand erstellen', description: 'Brief/Paket aus Ticket versenden', targets: ['ticket-detail'], moduleId: 'versand' },
            { id: 'shipping-tracking', name: 'Sendungsverfolgung', description: 'Tracking-Status zum Ticket', targets: ['ticket-detail'], moduleId: 'versand' },
        ],
    },
    // M12: Verträge & Abrechnung
    {
        id: 'vertraege',
        name: 'Verträge & Abrechnung',
        description: 'Vertragsverwaltung, Soll/Ist-Abgleich, Deckungsbeitrag, SAP-Übergabe',
        category: 'Finanzen',
        defaultStatus: 'beta',
        routes: [
            '/vertraege', '/vertraege/dashboard', '/vertraege/kundensicht',
            '/vertraege/typen', '/vertraege/kunden', '/vertraege/abgleich', '/vertraege/abrechnung',
            '/verkauf/vertraege', '/einkauf/vertraege',
            '/stammdaten/vertragsvorlagen', '/stammdaten/vertragsvorlagen/editor',
        ],
        icon: 'CreditCard',
        menuEntries: [
            // Kundenverträge under Kunden
            { route: '/vertraege', label: 'Kundenverträge', description: 'Alle Kundenverträge im Überblick', icon: 'FileText', category: 'Kunden', subGroup: 'Verwaltung & Verträge', end: true },
            // Lieferantenverträge under Lieferanten
            { route: '/einkauf/vertraege', label: 'Lieferantenverträge', description: 'Eingehende Verträge mit Lieferanten', icon: 'FileText', category: 'Lieferanten' },
            // Vertragsvorlagen under Stammdaten
            { route: '/stammdaten/vertragsvorlagen', label: 'Vorlagenbibliothek', description: 'Vertragsvorlagen verwalten & versionieren', icon: 'BookOpen', category: 'Stammdaten', subGroup: 'Vertragsvorlagen' },
            { route: '/stammdaten/vertragsvorlagen/editor', label: 'Vorlagen-Editor', description: 'Vertragsvorlage erstellen & bearbeiten', icon: 'PenLine', category: 'Stammdaten', subGroup: 'Vertragsvorlagen' },
        ],
        dashboardWidgets: [
            { id: 'billing-overview', name: 'Abrechnungsübersicht', description: 'Monatsumsatz, Deckungsbeitrag, offene Abrechnungen', defaultSize: { w: 6, h: 3 }, moduleId: 'vertraege' },
            { id: 'license-alerts', name: 'Lizenz-Abweichungen', description: 'Soll/Ist-Abweichungen bei Lizenzen', defaultSize: { w: 4, h: 3 }, moduleId: 'vertraege' },
        ],
        embeddableWidgets: [
            { id: 'customer-contracts', name: 'Kundenverträge', description: 'Aktive Verträge des Kunden', targets: ['customer-detail'], moduleId: 'vertraege' },
            { id: 'customer-billing', name: 'Kundenabrechnung', description: 'Letzte Abrechnungen + Deckungsbeitrag', targets: ['customer-detail'], moduleId: 'vertraege' },
        ],
    },
    // M13: Statistiken & Auswertungen
    {
        id: 'statistiken',
        name: 'Statistiken & Auswertungen',
        description: 'KPIs, Team-Übersicht und Reports',
        category: 'Finanzen',
        defaultStatus: 'stable',
        routes: ['/statistiken', '/auswertungen'],
        icon: 'BarChart3',
        menuEntries: [
            { route: '/statistiken', label: 'Statistiken', description: 'Zahlen & Trends' },
            { route: '/statistiken/dashboard', label: 'Mein Dashboard', description: 'Eigene KPI-Karten konfigurieren' },
            { route: '/statistiken/wcc', label: 'Working Capital Cycle', description: 'DSO · DPO · DIO · CCC' },
            { route: '/auswertungen/kunden', label: 'Auswertung: Kunden', description: 'Branchen, Geo, Aktivität' },
        ],
        dashboardWidgets: [
            { id: 'stats-kpi', name: 'KPI-Übersicht', description: 'Tickets gelöst, Umsatz etc.', defaultSize: { w: 6, h: 3 }, moduleId: 'statistiken' },
        ],
        embeddableWidgets: [],
    },
    // M14: Vertriebsboard
    {
        id: 'vertriebsboard',
        name: 'Vertriebsboard',
        description: 'Kanban-basierte Vertriebspipeline',
        category: 'Vertrieb',
        defaultStatus: 'beta',
        routes: ['/vertrieb'],
        icon: 'TrendingUp',
        menuEntries: [
            { route: '/vertrieb', label: 'Vertriebsboard', description: 'Kompletter Funnel: Recherche bis Gewonnen' },
        ],
        dashboardWidgets: [
            { id: 'sales-pipeline', name: 'Vertriebspipeline', description: 'Pipeline kompakt mit Anzahl + Wert pro Phase', defaultSize: { w: 12, h: 4 }, moduleId: 'vertriebsboard' },
        ],
        embeddableWidgets: [],
    },
    // M20: Neukundengewinnung
    {
        id: 'neukundengewinnung',
        name: 'Neukundengewinnung',
        description: 'Akquise, Stellenanzeigen & handgeschriebene Briefe (PENSAKI)',
        category: 'Vertrieb',
        defaultStatus: 'beta',
        routes: ['/neukundengewinnung'],
        icon: 'UserPlus',
        menuEntries: [
            { route: '/neukundengewinnung', label: 'Neukundengewinnung', description: 'Kampagnen, Briefe & Tagesansicht' },
            { route: '/neukundengewinnung/linkedin', label: 'LinkedIn Profile', description: 'LinkedIn-Konten verwalten & OAuth', icon: 'Linkedin' },
        ],
        dashboardWidgets: [
            { id: 'acquisition-daily', name: 'Heutige Briefe', description: 'Top 10 Prospects fuer den Tagesversand', defaultSize: { w: 6, h: 4 }, moduleId: 'neukundengewinnung' },
            { id: 'acquisition-kpis', name: 'Akquise-KPIs', description: 'Response-Rate, Termine, Deals', defaultSize: { w: 6, h: 2 }, moduleId: 'neukundengewinnung' },
        ],
        embeddableWidgets: [],
    },
    // M16: Kundenportal-Admin (eigene Kundenportal-App läuft unter meinimplec.de)
    {
        id: 'kundenportal-admin',
        name: 'Kundenportal-Admin',
        description: 'Verwaltung der Kundenportal-Accounts: Freischaltung, Kundenstamm-Zuordnung, TANSS-Credentials, Impersonation',
        category: 'Kunden',
        menuSubGroup: 'Verwaltung & Verträge',
        defaultStatus: 'beta',
        routes: ['/admin/kunden-user'],
        icon: 'Globe',
        menuEntries: [
            { route: '/admin/kunden-user', label: 'Kundenportal-Admin', description: 'Kunden-Accounts, Impersonation, TANSS-Creds' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M17: Terminplaner
    {
        id: 'terminplaner',
        name: 'Terminplaner',
        description: 'Team-Kalender, Massenplanung, Drag&Drop',
        category: 'Mein Arbeitsplatz',
        defaultStatus: 'beta',
        routes: ['/terminplaner'],
        icon: 'CalendarRange',
        menuEntries: [
            { route: '/terminplaner', label: 'Terminplaner', description: 'Team-Planung' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M17b: Terminbuchung (Termin zu Ticket buchen)
    {
        id: 'terminbuchung',
        name: 'Terminbuchung',
        description: 'Termin zu einem Ticket buchen',
        category: 'Mein Arbeitsplatz',
        defaultStatus: 'beta',
        routes: ['/terminbuchung'],
        icon: 'CalendarClock',
        menuEntries: [
            { route: '/terminbuchung', label: 'Terminbuchung', description: 'Termin zu Ticket buchen' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // Airkey: EVVA electronic locking system
    {
        id: 'airkey',
        name: 'Schlüsselverwaltung',
        description: 'EVVA Airkey – electronic locking system: locks, areas, persons, authorizations',
        category: 'Kunden',
        menuSubGroup: 'Infrastruktur & Technik',
        defaultStatus: 'beta',
        routes: ['/schluesselverwaltung', '/einstellungen/airkey'],
        icon: 'KeySquare',
        menuEntries: [
            { route: '/schluesselverwaltung', label: 'Schlüsselverwaltung', description: 'Airkey: Schlösser, Personen & Berechtigungen' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M18: Dokumentenverwaltung & Peripherie
    {
        id: 'dokumentation',
        name: 'Dokumentation & Peripherie',
        description: 'IT-Dokumentation, verschlüsselte PDFs, Peripherie-Smart-Copy',
        category: 'Kunden',
        menuSubGroup: 'Infrastruktur & Technik',
        defaultStatus: 'beta',
        routes: ['/dokumentation'],
        icon: 'FileCode',
        menuEntries: [
            { route: '/dokumentation', label: 'Dokumentation', description: 'IT-Doku & Peripherie' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M19: Urlaubsverwaltung
    {
        id: 'urlaub',
        name: 'Urlaubsverwaltung',
        description: 'Urlaubsanträge, Genehmigung, Resturlaub, Krankmeldungen',
        category: 'Mein Arbeitsplatz',
        defaultStatus: 'beta',
        routes: ['/urlaub'],
        icon: 'Palmtree',
        menuEntries: [
            { route: '/urlaub', label: 'Urlaub', description: 'Anträge & Übersicht' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M21: Rechnungseingang
    {
        id: 'rechnungseingang',
        name: 'Rechnungseingang',
        description: 'Eingangsrechnungen & Lieferantenportale',
        category: 'Lieferanten',
        defaultStatus: 'beta',
        routes: ['/rechnungen'],
        icon: 'Receipt',
        menuEntries: [
            { route: '/rechnungen', label: 'Rechnungseingang', description: 'Eingangsrechnungen & Portale' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M21b: Lieferanten / MSP-Dashboard
    {
        id: 'einkauf-lieferanten',
        name: 'Lieferanten / MSP',
        description: 'Zentrale Übersicht aller Lieferanten-Anbindungen und welcher Kunde welche Produkte hat',
        category: 'Lieferanten',
        defaultStatus: 'beta',
        routes: ['/einkauf/lieferanten'],
        icon: 'Truck',
        menuEntries: [
            { route: '/einkauf/lieferanten', label: 'Lieferanten / MSP', description: 'Anbindungen, Kunden-Produkte & Stammdaten-Abgleich' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M21d: Bedarfserfassung & SAP-Lagerbestand-Abgleich
    {
        id: 'einkauf-bedarfserfassung',
        name: 'Bedarfserfassung',
        description: 'Offene SAP-Aufträge gegen Lagerbestand prüfen, fehlende Artikel als Bedarfe erfassen',
        category: 'Lieferanten',
        defaultStatus: 'beta',
        routes: ['/einkauf/bedarfserfassung'],
        icon: 'ShoppingCart',
        menuEntries: [
            { route: '/einkauf/bedarfserfassung', label: 'Bedarfserfassung', description: 'SAP-Lagerprüfung & Bedarfsliste' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M21c: Hersteller-Lieferanten-Mapping (Einkauf)
    {
        id: 'einkauf-hersteller-mapping',
        name: 'Hersteller-Mapping',
        description: 'Bevorzugte Lieferanten je Hersteller mit Priorität und Zertifizierungsnotiz',
        category: 'Lieferanten',
        defaultStatus: 'beta',
        routes: ['/einkauf/hersteller-mapping'],
        icon: 'GitMerge',
        menuEntries: [
            { route: '/einkauf/hersteller-mapping', label: 'Hersteller-Mapping', description: 'Lieferanten je Hersteller & Einkaufspriorität' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M21e: Anfrageerstellung & Email-Versand (Einkauf M3)
    {
        id: 'einkauf-anfragen',
        name: 'Anfragen (RFQ)',
        description: 'Angebotsanfragen erstellen, Lieferanten per Email kontaktieren und Angebote sammeln',
        category: 'Lieferanten',
        defaultStatus: 'beta',
        routes: ['/einkauf/anfragen'],
        icon: 'Send',
        menuEntries: [
            { route: '/einkauf/anfragen', label: 'Anfragen', description: 'RFQ erstellen & Emails an Lieferanten senden' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M22: Kontoauszugsverarbeitung
    {
        id: 'finanzen-kontoauszuege',
        name: 'Kontoauszugsverarbeitung',
        description: 'SAP B1 Bank Statements – verbuchen & abschließen',
        category: 'Finanzen',
        defaultStatus: 'beta',
        routes: ['/finanzen/kontoauszuege'],
        icon: 'Landmark',
        menuEntries: [
            { route: '/finanzen/kontoauszuege', label: 'Kontoauszugsverarbeitung', description: 'SAP B1 Bank Statements – verbuchen & abschließen' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M24: Wiederkehrende Buchungen
    {
        id: 'finanzen-wiederkehrend',
        name: 'Wiederkehrende Buchungen',
        description: 'Regelmäßige Lastschriften & Eingänge erkennen',
        category: 'Finanzen',
        defaultStatus: 'beta',
        routes: ['/finanzen/wiederkehrend'],
        icon: 'Repeat',
        menuEntries: [
            { route: '/finanzen/wiederkehrend', label: 'Verträge & Fixkosten', description: 'Wiederkehrende Ausgaben aus Kontoauszügen erkennen' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M23: BWA & Liquidität
    {
        id: 'finanzen-bwa',
        name: 'BWA & Liquidität',
        description: 'Auswertung & Forecast',
        category: 'Finanzen',
        defaultStatus: 'beta',
        routes: ['/finanzen/bwa'],
        icon: 'LineChart',
        menuEntries: [
            { route: '/finanzen/bwa', label: 'BWA & Liquidität', description: 'Auswertung & Forecast' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M27: Sicherheitsrichtlinien
    {
        id: 'sicherheitsrichtlinien',
        name: 'Sicherheitsrichtlinien',
        description: 'implec-Richtlinienkatalog, Kunden-Overrides und Security Score',
        category: 'Kunden',
        menuSubGroup: 'Infrastruktur & Technik',
        defaultStatus: 'beta',
        routes: ['/infrastruktur/sicherheitsrichtlinien', '/infrastruktur/sicherheitsrichtlinien/*'],
        icon: 'ShieldCheck',
        menuEntries: [
            { route: '/infrastruktur/sicherheitsrichtlinien', label: 'Sicherheitsrichtlinien', description: 'Policy-Verwaltung & Security Score' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M26: IT-Strukturen & Compliance
    {
        id: 'it-strukturen',
        name: 'IT-Strukturen & Compliance',
        description: 'AD-Strukturen, Zugriffsmatrix und NIS2-konformes Deployment-Log',
        category: 'Kunden',
        menuSubGroup: 'Infrastruktur & Technik',
        defaultStatus: 'beta',
        routes: ['/infrastruktur/strukturen', '/infrastruktur/strukturen/*'],
        icon: 'Shield',
        menuEntries: [
            { route: '/infrastruktur/strukturen', label: 'IT-Strukturen & Compliance', description: 'AD-Strukturen & Deployment' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M25: OPOS – Offene Posten
    {
        id: 'finanzen-opos',
        name: 'OPOS – Offene Posten',
        description: 'Offene Forderungen und Verbindlichkeiten aus SAP B1',
        category: 'Finanzen',
        defaultStatus: 'beta',
        routes: ['/finanzen/opos'],
        icon: 'Scale',
        menuEntries: [
            { route: '/finanzen/opos', label: 'OPOS', description: 'Offene Posten – Debitoren & Kreditoren' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M28: Liquiditätsplanung
    {
        id: 'finanzen-liquiditaet',
        name: 'Liquiditätsplanung',
        description: 'SOLL/IST-Liquiditätsplanung pro Mandant + Konzern-Forecast über alle SAP-Mandanten',
        category: 'Finanzen',
        defaultStatus: 'beta',
        routes: ['/finanzen/liquiditaet/planung'],
        icon: 'TrendingDown',
        menuEntries: [
            { route: '/finanzen/liquiditaet/planung', label: 'Liquiditätsplanung', description: 'SOLL/IST-Planung pro Mandant + Konzern-Forecast' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M28b: Integrierte Planung (GuV + Bilanz + Cash-Flow, Konzern & Intercompany)
    // Konzept: docs/planning/liquiditaetsplanung/INTEGRIERTE-KONZERNPLANUNG.md
    {
        id: 'finanzen-integrierteplanung',
        name: 'Integrierte Planung',
        description: 'Integrierte Finanzplanung (GuV + Bilanz + Cash-Flow), Konzern-Konsolidierung & Intercompany',
        category: 'Finanzen',
        defaultStatus: 'beta',
        routes: ['/finanzen/integrierteplanung'],
        icon: 'TrendingUp',
        menuEntries: [
            { route: '/finanzen/integrierteplanung', label: 'Integrierte Planung', description: 'GuV · Bilanz · Cash-Flow pro Gesellschaft' },
            { route: '/finanzen/integrierteplanung/konzern', label: 'Konzern-Konsolidierung', description: 'Konsolidierte Sicht über alle Gesellschaften' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M31: Automatic Support Workflow (CODA-2460)
    {
        id: 'finanzen-automatic-support-workflow',
        name: 'Support-Workflow',
        description: 'TANSS-Supports der letzten Tage nach Freigabe-Status (cleared / other) gruppiert',
        category: 'Finanzen',
        defaultStatus: 'beta',
        routes: ['/finanzen/support-workflow'],
        icon: 'ClipboardCheck',
        menuEntries: [
            { route: '/finanzen/support-workflow', label: 'Support-Workflow', description: 'Leistungen nach Freigabe-Status gruppiert' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M27: Dev-Tools (Diagnose & Debugging)
    {
        id: 'dev-tools',
        name: 'Dev-Tools',
        description: 'Diagnose-Werkzeuge: TANSS-API-Viewer, Sync-Map, Job-History',
        category: 'Stammdaten',
        defaultStatus: 'beta',
        routes: ['/dev-tools'],
        icon: 'Wrench',
        // Dev-Tools werden über das Utility-Menü aufgerufen, nicht über die Hauptnavigation.
        menuEntries: [],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // GP: Geschäftspartner (Kunden + Lieferanten, aggregiert aus SAP + TANSS)
    {
        id: 'geschaeftspartner',
        name: 'Geschäftspartner',
        description: 'Kunden- und Lieferantenstammdaten, Dokumente, Verträge, KPIs und Kampagnen',
        category: 'Stammdaten',
        menuSubGroup: 'Geschäftspartner',
        defaultStatus: 'beta',
        routes: ['/gp', '/gp/:id'],
        icon: 'Building2',
        menuEntries: [
            // Kundenübersicht as entry point under Kunden
            { route: '/gp', label: 'Kundenübersicht', description: 'Alle Kunden im Überblick', icon: 'Users', category: 'Kunden', subGroup: 'Verwaltung & Verträge', end: true },
            // Full GP hub in Stammdaten
            { route: '/gp', label: 'Übersicht', description: 'Alle Geschäftspartner', end: true },
            { route: '/gp/datenpflege', label: 'Datenpflege', description: 'Qualität, Dubletten, TANSS-Match' },
            { route: '/gp/kampagnen', label: 'Kampagnen', description: 'Massenanschreiben & Token-Formulare' },
            { route: '/gp/posteingang', label: 'Posteingang', description: 'Formular-Eingaben prüfen & freigeben' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M15: Artikelverwaltung
    {
        id: 'artikel',
        name: 'Artikelverwaltung',
        description: 'Artikelstamm, Preise, Stücklisten, KI-Texte, EGIS-Import, SAP-Sync',
        category: 'Stammdaten',
        menuSubGroup: 'Artikel',
        defaultStatus: 'beta',
        routes: ['/artikel', '/artikel/gruppen', '/artikel/garantien'],
        icon: 'Database',
        menuEntries: [
            { route: '/artikel', label: 'Artikelverwaltung', description: 'Artikel, Preise, Stücklisten' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [
            { id: 'artikel-search', name: 'Artikelsuche', description: 'Artikelsuche + EGIS-Import + sofortige Anlage', targets: ['sap-create'], moduleId: 'artikel' },
            { id: 'artikel-bom', name: 'Stückliste', description: 'Stückliste auflösen: Hauptartikel → alle Positionen', targets: ['sap-create'], moduleId: 'artikel' },
        ],
    },
    // M28: TANSS ↔ Microsoft-Teams-Bridge
    {
        id: 'tanss-teams-bridge',
        name: 'TANSS ↔ Teams Bridge',
        description: 'Spiegelung ticketbezogener TANSS-Chats nach Microsoft Teams. Status, ' +
            'Fehler, User-Mapping und Subscriptions im Blick. Doku: ' +
            'docs/architecture/tanss-teams-bridge.md',
        category: 'Stammdaten',
        defaultStatus: 'beta',
        routes: ['/admin/tanss-teams-bridge'],
        icon: 'MessagesSquare',
        // Reached via the Wrench-dropdown in the header, not the main navigation.
        menuEntries: [],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M29: TANSS/Outlook-Sync
    {
        id: 'tanss-outlook-sync',
        name: 'TANSS/Outlook-Sync',
        description: 'Kalender-Synchronisation zwischen TANSS-Supports und Microsoft Outlook (M365) – Titel-Vorlagen, Sync-Fenster und Diagnose',
        category: 'Stammdaten',
        defaultStatus: 'stable',
        routes: [],
        icon: 'Calendar',
        menuEntries: [],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M31: Neukundenonboarding (implec-seitig)
    {
        id: 'neukundenonboarding',
        name: 'Neukundenonboarding',
        description: 'Geführter Wizard zur Anlage neuer Kunden: Stammdaten, SAP-BP, Vertragsdokumente, Portal-Link',
        category: 'Kunden',
        menuSubGroup: 'Verwaltung & Verträge',
        defaultStatus: 'beta',
        routes: ['/neukundenonboarding'],
        icon: 'UserCheck',
        menuEntries: [
            { route: '/neukundenonboarding', label: 'Neukundenonboarding', description: 'Kunden anlegen & Onboarding starten' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M32: Prozesse – NIS2/KRITIS-konformes Prozessmodul
    {
        id: 'prozesse',
        name: 'Prozesse',
        description: 'Strukturierte Abläufe, Freigabeprozesse und NIS2/KRITIS-konformes Audit-Log',
        category: 'Stammdaten',
        menuSubGroup: 'Prozesse',
        defaultStatus: 'beta',
        routes: ['/prozesse', '/prozesse/:id', '/prozesse/freigaben', '/prozesse/templates', '/prozesse/templates/:id/designer', '/prozesse/rollen-profile'],
        icon: 'GitBranch',
        menuEntries: [
            { route: '/prozesse', label: 'Prozesse', description: 'Abläufe & Freigaben' },
            { route: '/prozesse/freigaben', label: 'Meine Freigaben', description: 'Offene Freigabeanfragen' },
            { route: '/prozesse/templates', label: 'Vorlagen', description: 'Prozess-Vorlagen verwalten' },
            { route: '/prozesse/rollen-profile', label: 'Rollen-Profile', description: 'Hardware-/Rechte-/Lizenz-Sets je Rolle' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M30: E-Mail-Posteingang (M365 bidirectional ticket linking)
    {
        id: 'email-posteingang',
        name: 'E-Mail-Posteingang',
        description: 'Microsoft-365-Posteingang mit bidirektionaler Ticket-Verknüpfung',
        category: 'Mein Arbeitsplatz',
        defaultStatus: 'beta',
        routes: ['/email/posteingang'],
        icon: 'Mail',
        menuEntries: [
            { route: '/email/posteingang', label: 'Posteingang', description: 'M365-Posteingang & Ticket-Verknüpfung' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M31: Marketing – Content-Vorgaben-Editor
    {
        id: 'marketing',
        name: 'Marketing',
        description: 'Content-Vorgaben, Styleguide und kanal-spezifische Briefs für KI-gestützte Texterstellung',
        category: 'Vertrieb',
        defaultStatus: 'beta',
        routes: ['/marketing/content-briefs'],
        icon: 'Megaphone',
        menuEntries: [
            { route: '/marketing/content-briefs', label: 'Content-Vorgaben', description: 'Styleguide & kanal-spezifische Briefs' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M32: Marketing – SEO On-Page-Analyse & Dashboard
    {
        id: 'marketing-seo',
        name: 'SEO-Analyse',
        description: 'KI-gestützte On-Page-SEO-Prüfung: Titel, Meta-Description, H1/H2-Struktur, Keyword-Dichte, interne Verlinkung',
        category: 'Vertrieb',
        defaultStatus: 'beta',
        routes: ['/marketing/seo'],
        icon: 'Search',
        menuEntries: [
            { route: '/marketing/seo', label: 'SEO-Analyse', description: 'On-Page-Analyse & KI-Empfehlungen' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // Paperclip: Interne Issue-Verwaltung (nur Admins)
    {
        id: 'paperclip',
        name: 'Paperclip Issues',
        description: 'Interne Aufgaben und Issues aus Paperclip – nur für Admins sichtbar',
        category: 'Administration',
        defaultStatus: 'stable',
        routes: ['/paperclip'],
        icon: 'Paperclip',
        menuEntries: [
            { route: '/paperclip', label: 'Paperclip', description: 'Interne Issues & Aufgaben' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M33: Disposition – Service-Desk Wochenplanung, Außeneinsatz, Leistungsfreigabe
    {
        id: 'dispo',
        name: 'Disposition',
        description: 'Service-Desk Wochenplanung, Außeneinsatz, Leistungsfreigabe und Ticketprüfung',
        category: 'Disposition',
        defaultStatus: 'beta',
        routes: ['/dispo', '/dispo/service-desk', '/dispo/ausseneinsatz', '/dispo/leistungsfreigabe', '/dispo/ticketpruefung', '/dispo/email-vorlagen', '/dispo/kalender', '/dispo/krankenstand', '/dispo/abwesenheit', '/dispo/chef-uebersicht', '/einstellungen/dispo', '/einstellungen/dispo/leistungsfreigabe', '/einstellungen/dispo/dienste'],
        icon: 'CalendarCheck',
        menuEntries: [
            { route: '/dispo/service-desk', label: 'Wochenplanung', description: 'Service-Desk Wochenplanung', icon: 'CalendarCheck' },
            { route: '/dispo/ausseneinsatz', label: 'Außeneinsatz', description: 'Außeneinsatz-Planung & Kundenterminierung per E-Mail', icon: 'MapPin' },
            { route: '/dispo/leistungsfreigabe', label: 'Leistungsfreigabe', description: 'Erbrachte Leistungen prüfen & freigeben', icon: 'CheckSquare' },
            { route: '/dispo/ticketpruefung', label: 'Ticketprüfung', description: 'Tickets auf Vollständigkeit prüfen', icon: 'ClipboardCheck' },
            { route: '/dispo/chef-uebersicht', label: 'Chef-Übersicht', description: 'Kritische Tickets & fragwürdige Zeiteinträge', icon: 'ShieldAlert' },
            { route: '/dispo/email-vorlagen', label: 'E-Mail-Vorlagen', description: 'Vorlagen für Dispo-E-Mails verwalten', icon: 'Mail' },
            { route: '/dispo/kalender', label: 'Dispo-Kalender', description: 'Teamkalender & Übersicht', icon: 'CalendarRange' },
            { route: '/dispo/krankenstand', label: 'Krankenstand', description: 'Abwesende Mitarbeiter und deren offene Tickets', icon: 'Thermometer' },
            { route: '/dispo/abwesenheit', label: 'Abwesenheitsübersicht', description: 'Alle Abwesenheiten im Zeitraum inkl. Outlook-Sync', icon: 'CalendarX2' },
            { route: '/einstellungen/dispo', label: 'Dispo-Einstellungen', description: 'Schwellenwerte, Schicht-Config & E-Mail-Absender', icon: 'Settings' },
            { route: '/einstellungen/dispo/dienste', label: 'Dienstdefinitionen', description: 'Globale Dienste & Schichtregeln für Wochenplanung (Admin)', icon: 'Settings2' },
        ],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
    // M34: Leistungsfreigabe – Übersteuerungsberechtigung (kein Menüeintrag, reine Permission)
    {
        id: 'dispo.freigabe.override',
        name: 'Leistungsfreigabe – Übersteuerung',
        description: 'Erlaubt das manuelle Übersteuern blockierter Leistungsfreigaben (mit Begründungspflicht)',
        category: 'Disposition',
        defaultStatus: 'stable',
        routes: [],
        icon: 'ShieldCheck',
        menuEntries: [],
        dashboardWidgets: [],
        embeddableWidgets: [],
    },
];
// ─── Helpers ──────────────────────────────────────────────────────────────────
/** Get all dashboard widgets from all modules */
export function getAllDashboardWidgets() {
    return MODULE_DEFINITIONS.flatMap((m) => m.dashboardWidgets);
}
/** Get all embeddable widgets for a given target page */
export function getEmbeddableWidgets(target) {
    return MODULE_DEFINITIONS.flatMap((m) => m.embeddableWidgets.filter((w) => w.targets.includes(target)));
}
/** Get module by ID */
export function getModule(id) {
    return MODULE_DEFINITIONS.find((m) => m.id === id);
}
/** Get modules grouped by category (stable category order). */
export function getModulesByCategory() {
    const grouped = {};
    // Pre-seed in stable order so insertion order matches MODULE_CATEGORY_ORDER
    for (const cat of MODULE_CATEGORY_ORDER) {
        grouped[cat] = [];
    }
    for (const mod of MODULE_DEFINITIONS) {
        if (!grouped[mod.category])
            grouped[mod.category] = [];
        grouped[mod.category].push(mod);
    }
    return grouped;
}
/** System settings key for a module's status */
export function moduleStatusKey(moduleId) {
    return `module.${moduleId}.status`;
}
/**
 * Build the main navigation from `MODULE_DEFINITIONS`. Single source of truth
 * shared with the settings module list — adding/removing a module here
 * automatically updates both the menu and the settings page.
 */
export function getMenuCategories() {
    const byCategory = new Map();
    for (const cat of MODULE_CATEGORY_ORDER)
        byCategory.set(cat, []);
    for (const mod of MODULE_DEFINITIONS) {
        // `undefined` → derive a single default entry; `[]` → hide from menu.
        const entries = mod.menuEntries ?? [
            { route: mod.routes[0] ?? '/', label: mod.name, description: mod.description, icon: mod.icon },
        ];
        for (const entry of entries) {
            const cat = entry.category ?? mod.category;
            const list = byCategory.get(cat) ?? [];
            list.push({
                moduleId: mod.id,
                route: entry.route,
                label: entry.label ?? mod.name,
                description: entry.description ?? mod.description,
                icon: entry.icon ?? mod.icon,
                category: cat,
                sapPermission: entry.sapPermission,
                end: entry.end,
                subGroup: entry.subGroup ?? mod.menuSubGroup,
            });
            byCategory.set(cat, list);
        }
    }
    return MODULE_CATEGORY_ORDER
        .map((category) => ({ category, entries: byCategory.get(category) ?? [] }))
        .filter((group) => group.entries.length > 0);
}
//# sourceMappingURL=modules.js.map